import ResourceService from "./resource.service";
import Vue from "vue";

class ProformaInvoiceService extends ResourceService {
  static get resource() {
    return "proforma-invoice";
  }
  static downloadPDF(slug) {
    const url = `${this.resource}/${slug}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { responseType: "blob", })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}

export default ProformaInvoiceService;
